import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid = false, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full px-3 py-2 rounded-lg text-base',
        'bg-surface-2 border-0 resize-none',
        'transition-shadow duration-150',
        'placeholder:text-hint',
        'focus:outline-none focus:ring-2',
        invalid ? 'ring-2 ring-destructive/60 focus:ring-destructive/60' : 'focus:ring-ink/70',
        className,
      )}
      {...rest}
    />
  );
});
